import { useStaticQuery, graphql } from 'gatsby'

export const useContactForm = () => {
    const { allContentfulForm } = useStaticQuery(
        graphql`
            query formQuery {
            allContentfulForm(
                filter: { property: { name: { regex: "/pazola/i" } } }
            ) {
                edges {
                    node {
                        formTitle
                        node_locale
                        formCopy {
                            childMarkdownRemark {
                                html
                            }
                        }
                        property {
                            name
                        }
                    }
                }
            }
        }
        `
    )

    return allContentfulForm;
}
